export const DEFAULT_NEXT_HISTORY_LENGTh = 2 // nextJs default 2 length
